import { Injectable } from '@angular/core';
import 'rxjs/add/operator/map';
import { Database } from '../database';


@Injectable()
export class BllRememberAcc extends Database {

  constructor() {
    super("App_User")
  }

}



// WEBPACK FOOTER //
// ./src/providers/bll/bll-remember-acc.ts